document.addEventListener("DOMContentLoaded", function () {
  const banners = document.querySelectorAll(".ragdoll_video_wrapper");

  banners.forEach(function (wrapper) {
    const slides = Array.from(wrapper.querySelectorAll(".ragdoll_video_slide"));
    const content = wrapper.querySelector(".ragdoll_video_content");
    const heading = wrapper.querySelector(".ragdoll_video_heading");
    const captionList = wrapper.querySelector(".ragdoll_video_caption_list");
    const button = wrapper.querySelector(".ragdoll_video_button");

    let currentVideoIndexInGroup = 0;
    let slideTimer;
    let currentHeading = "";
    let isLoadingGroup = false;
    let imageScrollTicking = false;

    if (!slides.length) return;

    const groupMap = {};
    const groupOrder = [];

    slides.forEach(function (slide) {
      const groupId = slide.dataset.group || "default";

      if (!groupMap[groupId]) {
        groupMap[groupId] = [];
        groupOrder.push(groupId);
      }

      groupMap[groupId].push(slide);
    });

    const validGroups = groupOrder.map(function (groupId) {
      return groupMap[groupId];
    }).filter(function (group) {
      return group && group.length;
    });

    if (!validGroups.length) return;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function updateImageScrollEffect() {
      const banner = wrapper.closest(".ragdoll_video_banner");

      if (!banner) {
        return;
      }

      const bannerRect = banner.getBoundingClientRect();
      const bannerHeight = banner.offsetHeight;

      if (!bannerHeight) {
        return;
      }

      const progress = clamp(-bannerRect.top / bannerHeight, 0, 1);

      const imageSlides = wrapper.querySelectorAll(
        '.ragdoll_video_slide[data-media-type="image"]'
      );

      imageSlides.forEach(function (slide) {
        const image = slide.querySelector(".ragdoll_video_image");

        if (!image) {
          return;
        }

        if (!slide.classList.contains("is_active")) {
          image.style.setProperty("--ragdoll_image_scroll_y", "0px");
          return;
        }

        const slideHeight = slide.offsetHeight;

        if (!slideHeight) {
          return;
        }

        const maxScroll = Math.max(image.offsetHeight - slideHeight, 0);
        const y = -maxScroll * progress;

        image.style.setProperty("--ragdoll_image_scroll_y", y + "px");
      });
    }

    function requestImageScrollEffect() {
      if (imageScrollTicking) {
        return;
      }

      imageScrollTicking = true;

      requestAnimationFrame(function () {
        updateImageScrollEffect();
        imageScrollTicking = false;
      });
    }

    function getNextGroupIndex(groupIndex) {
      return groupIndex + 1 >= validGroups.length ? 0 : groupIndex + 1;
    }

    function getMediaType(slide) {
      return slide.dataset.mediaType || "video";
    }

    function isStaticGroup(group) {
      return group[0].dataset.staticSlide === "true";
    }

    function preloadGroup(groupIndex) {
      const group = validGroups[groupIndex];

      if (!group) return;

      group.forEach(function (slide) {
        if (getMediaType(slide) !== "video") return;

        const video = slide.querySelector(".ragdoll_video");

        if (!video) return;

        video.preload = "auto";

        if (video.readyState < 2) {
          video.load();
        }
      });
    }

    function updateButtonFromGroup(group, shouldAnimateText = true) {
      const firstSlide = group[0];
      const buttonText = firstSlide.dataset.buttonText || "";
      const buttonLink = firstSlide.dataset.buttonLink || "#";

      if (buttonText !== "") {
        button.textContent = buttonText;
        button.href = buttonLink;
        button.classList.remove("is_hidden");

        if (shouldAnimateText) {
          button.classList.remove("is_visible");
          button.style.transition = "none";
          button.offsetHeight;
          button.style.transition = "";

          setTimeout(function () {
            button.classList.add("is_visible");
          }, 400);
        } else {
          button.classList.add("is_visible");
        }
      } else {
        button.classList.remove("is_visible");
        button.classList.add("is_hidden");
      }
    }

    function renderCaptionList(group, activeIndex) {
      captionList.innerHTML = "";

      group.forEach(function (slide, index) {
        const caption = slide.dataset.videoCaption || "";

        if (caption === "") return;

        const item = document.createElement("li");
        item.textContent = caption;

        if (index === activeIndex) {
          item.classList.add("is_active");
        }

        captionList.appendChild(item);
      });
    }

    function updateCaptionActiveState(activeIndex) {
      const items = captionList.querySelectorAll("li");

      items.forEach(function (item, index) {
        if (index === activeIndex) {
          item.classList.add("is_active");
        } else {
          item.classList.remove("is_active");
        }
      });
    }

    function animateContentIn() {
      content.classList.remove("is_animating");
      void content.offsetHeight;
      content.classList.add("is_visible");
      content.classList.add("is_animating");
    }

    function updateTextFromGroup(group, shouldAnimateText) {
      const firstSlide = group[0];
      const newHeading = firstSlide.dataset.heading || "";

      currentHeading = newHeading;

      heading.textContent = newHeading;
      renderCaptionList(group, 0);
      updateButtonFromGroup(group, shouldAnimateText);

      if (shouldAnimateText) {
        animateContentIn();
      } else {
        content.classList.add("is_visible");
      }
    }

    function pauseSlideMedia(slide) {
      const video = slide.querySelector(".ragdoll_video");

      if (video) {
        video.pause();
      }
    }

  function hideAllSlides() {
  slides.forEach(function (slide) {
    pauseSlideMedia(slide);
    slide.classList.remove("is_active");
    slide.classList.remove("is_video_ready");
  });
}

    function resetVideo(video) {
      if (!video) return;

      video.pause();

      try {
        video.currentTime = 0;
      } catch (error) {}
    }

    function resetGroupVideos(group) {
      group.forEach(function (slide) {
        resetVideo(slide.querySelector(".ragdoll_video"));
      });
    }

    function waitForVideo(video, callback) {
      if (!video) {
        callback();
        return;
      }

      if (video.readyState >= 4) {
        callback();
        return;
      }

      video.addEventListener("canplaythrough", function () {
        callback();
      }, { once: true });

      if (video.readyState < 2) {
        video.load();
      }
    }

    function waitForImage(image, callback) {
      if (!image) {
        callback();
        return;
      }

      if (image.complete) {
        callback();
        return;
      }

      image.addEventListener("load", callback, { once: true });
      image.addEventListener("error", callback, { once: true });
    }

    function waitForSlide(slide, callback) {
      const mediaType = getMediaType(slide);

      if (mediaType === "video") {
        waitForVideo(slide.querySelector(".ragdoll_video"), callback);
        return;
      }

      if (mediaType === "image") {
        waitForImage(slide.querySelector(".ragdoll_video_image"), callback);
        return;
      }

      callback();
    }

    function waitForGroup(group, callback) {
      let loadedCount = 0;

      group.forEach(function (slide) {
        waitForSlide(slide, function () {
          loadedCount++;

          if (loadedCount === group.length) {
            callback();
          }
        });
      });
    }

    function showGroupLoadingState(group, shouldAnimateText) {
      clearTimeout(slideTimer);
      hideAllSlides();
      currentVideoIndexInGroup = 0;
      updateTextFromGroup(group, shouldAnimateText);
      updateImageScrollEffect();
    }

    function startSlideTimer(groupIndex, videoIndex, nextGroupIndex, slide) {
      const group = validGroups[groupIndex];

      if (isStaticGroup(group)) {
        return;
      }

      const currentDuration = Number(slide.dataset.videoDuration || 5) * 1000;

      clearTimeout(slideTimer);

      slideTimer = setTimeout(function () {
        const nextVideoIndex = videoIndex + 1;

        if (nextVideoIndex < group.length) {
          playMediaInGroup(groupIndex, nextVideoIndex);
        } else {
          showGroup(nextGroupIndex);
        }
      }, currentDuration);
    }

 function activateSlide(slide) {
  const currentActiveSlide = wrapper.querySelector(
    ".ragdoll_video_slide.is_active"
  );

  slide.classList.remove("is_video_ready");
  slide.classList.add("is_active");

  requestAnimationFrame(function () {
    if (currentActiveSlide && currentActiveSlide !== slide) {
      pauseSlideMedia(currentActiveSlide);
      currentActiveSlide.classList.remove("is_active");
      currentActiveSlide.classList.remove("is_video_ready");
    }

    requestAnimationFrame(function () {
      updateImageScrollEffect();
    });
  });
}

    function playMediaInGroup(groupIndex, videoIndex) {
      clearTimeout(slideTimer);

      const group = validGroups[groupIndex];
      const nextGroupIndex = getNextGroupIndex(groupIndex);
      const slide = group[videoIndex];
      const mediaType = getMediaType(slide);
      const video = slide.querySelector(".ragdoll_video");

      if (videoIndex === 0 && !isStaticGroup(group)) {
        preloadGroup(nextGroupIndex);
      }

      currentVideoIndexInGroup = videoIndex;
      updateCaptionActiveState(videoIndex);

      activateSlide(slide);

      if (mediaType !== "video" || !video) {
        startSlideTimer(groupIndex, videoIndex, nextGroupIndex, slide);
        return;
      }

      try {
        video.currentTime = 0;
      } catch (error) {}

     slide.classList.remove("is_video_ready");

video.play().then(function () {
  requestAnimationFrame(function () {
    slide.classList.add("is_video_ready");

    requestAnimationFrame(function () {
      startSlideTimer(groupIndex, videoIndex, nextGroupIndex, slide);
    });
  });
}).catch(function () {
  slide.classList.add("is_video_ready");
  startSlideTimer(groupIndex, videoIndex, nextGroupIndex, slide);
});
    }

    function showGroup(groupIndex) {
      clearTimeout(slideTimer);

      if (isLoadingGroup) return;

      isLoadingGroup = true;

      const group = validGroups[groupIndex];

      currentVideoIndexInGroup = 0;

      const activeSlide = wrapper.querySelector(".ragdoll_video_slide.is_active");
      const activeGroup = activeSlide ? activeSlide.dataset.group : null;
      const nextGroup = group[0] ? group[0].dataset.group : null;
      const shouldAnimateText = activeGroup !== nextGroup;

      showGroupLoadingState(group, shouldAnimateText);
      resetGroupVideos(group);

      waitForGroup(group, function () {
        isLoadingGroup = false;
        playMediaInGroup(groupIndex, 0);
      });
    }

    function startBanner() {
      clearTimeout(slideTimer);
      currentHeading = "";
      isLoadingGroup = false;

      preloadGroup(0);
      showGroup(0);
      updateImageScrollEffect();
    }

    startBanner();

    window.addEventListener("scroll", requestImageScrollEffect, { passive: true });
    window.addEventListener("resize", requestImageScrollEffect);

    window.addEventListener("pageshow", function (event) {
      if (event.persisted) {
        startBanner();
      } else {
        updateImageScrollEffect();
      }
    });

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        clearTimeout(slideTimer);
      } else {
        startBanner();
      }
    });

    document.addEventListener("shopify:section:load", function () {
      updateImageScrollEffect();
    });
  });
});